/**
 * SolutionSection - 솔루션 소개 섹션
 *
 * 채점톡이 제공하는 4가지 핵심 기능 소개
 * - 시중 문제집 지원
 * - 자동 채점
 * - 답 비노출
 * - 오답 관리
 */

import React from 'react';
import { Typography, Row, Col, Card } from 'antd';
import {
  BookOutlined,
  ThunderboltOutlined,
  LockOutlined,
  BarChartOutlined,
} from '@ant-design/icons';

const { Title, Text } = Typography;

// 솔루션 기능 데이터
const features = [
  {
    icon: <BookOutlined style={{ fontSize: '32px', color: '#667eea' }} />,
    title: '시중 문제집 지원',
    description: '사용하시는 문제집, 이미 등록되어 있습니다. 별도 입력 없이 바로 사용하세요.',
    highlight: '입력 부담 제로',
  },
  {
    icon: <ThunderboltOutlined style={{ fontSize: '32px', color: '#667eea' }} />,
    title: '자동 채점',
    description: '객관식, OX, 숫자, 수식까지 학생이 답을 제출하면 즉시 자동 채점됩니다.',
    highlight: '실시간 결과',
  },
  {
    icon: <LockOutlined style={{ fontSize: '32px', color: '#667eea' }} />,
    title: '답 비노출',
    description: '학생은 정답/오답 여부만 확인합니다. 정답은 절대 노출되지 않아요.',
    highlight: '진짜 학습 효과',
  },
  {
    icon: <BarChartOutlined style={{ fontSize: '32px', color: '#667eea' }} />,
    title: '오답 관리',
    description: '강사가 재채점을 허락하면 학생은 오답만 다시 풀 수 있습니다.',
    highlight: '체계적 복습',
  },
];

export const SolutionSection: React.FC = () => {
  return (
    <section
      style={{
        background: '#fff',
        padding: '80px 24px',
      }}
    >
      <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
        {/* 섹션 제목 */}
        <div style={{ textAlign: 'center', marginBottom: '48px' }}>
          <Text
            style={{
              color: '#667eea',
              fontSize: '14px',
              fontWeight: 600,
              letterSpacing: '2px',
              textTransform: 'uppercase',
            }}
          >
            Solution
          </Text>
          <Title
            level={2}
            style={{
              marginTop: '8px',
              marginBottom: '16px',
              fontSize: 'clamp(24px, 4vw, 36px)',
            }}
          >
            채점톡이 해결해드립니다
          </Title>
          <Text
            type="secondary"
            style={{
              fontSize: '16px',
              maxWidth: '600px',
              display: 'block',
              margin: '0 auto',
            }}
          >
            수학 채점에 최적화된 자동 채점 시스템
          </Text>
        </div>

        {/* 기능 카드들 */}
        <Row gutter={[24, 24]}>
          {features.map((feature, index) => (
            <Col xs={24} sm={12} md={6} key={index}>
              <Card
                bordered={false}
                style={{
                  height: '100%',
                  borderRadius: '16px',
                  background: '#f8f9ff',
                  border: '1px solid #e8eaff',
                }}
                bodyStyle={{ padding: '32px 24px' }}
              >
                {/* 아이콘 */}
                <div
                  style={{
                    width: '64px',
                    height: '64px',
                    borderRadius: '12px',
                    background: '#fff',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    marginBottom: '20px',
                    boxShadow: '0 2px 8px rgba(102, 126, 234, 0.15)',
                  }}
                >
                  {feature.icon}
                </div>

                {/* 제목 */}
                <Title
                  level={5}
                  style={{
                    marginBottom: '12px',
                    fontSize: '17px',
                  }}
                >
                  {feature.title}
                </Title>

                {/* 설명 */}
                <Text
                  type="secondary"
                  style={{
                    fontSize: '14px',
                    lineHeight: 1.7,
                    display: 'block',
                    marginBottom: '16px',
                  }}
                >
                  {feature.description}
                </Text>

                {/* 하이라이트 태그 */}
                <div
                  style={{
                    display: 'inline-block',
                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                    color: '#fff',
                    padding: '4px 12px',
                    borderRadius: '12px',
                    fontSize: '12px',
                    fontWeight: 600,
                  }}
                >
                  {feature.highlight}
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </section>
  );
};
